export const ASSETS = {
  monogram: "https://customer-assets.emergentagent.com/job_miguel-ventures/artifacts/wx5tsl6w_99D072EE-6F5D-4B5E-9AE6-FE81273D792D.png",
  monogramLegacy: "https://customer-assets.emergentagent.com/job_05f1a4c6-b66f-4698-bb7b-fd0bde30e780/artifacts/w839l4i2_IMG_4105.jpeg",
  signature: "https://customer-assets.emergentagent.com/job_05f1a4c6-b66f-4698-bb7b-fd0bde30e780/artifacts/7puj6e74_B3EE91F8-76D3-4C90-8058-8109737AC237.png",
  portrait1: "https://customer-assets.emergentagent.com/job_05f1a4c6-b66f-4698-bb7b-fd0bde30e780/artifacts/3jpvizn0_89455F05-508B-44FE-9C08-A61D252061D5.png",
  portrait2: "https://customer-assets.emergentagent.com/job_05f1a4c6-b66f-4698-bb7b-fd0bde30e780/artifacts/e5cg5pyh_2BAD9340-0536-4E95-BC3E-68AB0F09684F.png",
  portrait3: "https://customer-assets.emergentagent.com/job_05f1a4c6-b66f-4698-bb7b-fd0bde30e780/artifacts/xlllq661_620CA33C-4C26-4FAC-A309-3562AD7CB1C8.png",
  cityBg: {
    lasVegas: "https://static.prod-images.emergentagent.com/jobs/05f1a4c6-b66f-4698-bb7b-fd0bde30e780/images/65a13aae0baf7e82fe1ea035e6d5b6625fdf4db2375655274f86a18d886608cf.png",
    losAngeles: "https://static.prod-images.emergentagent.com/jobs/05f1a4c6-b66f-4698-bb7b-fd0bde30e780/images/3c3facd0c8b47a378c2ba8dfbd7ac7ac4cfe171f0be9dc3f987e3c72fd2a8e5d.png",
    newYork: "https://static.prod-images.emergentagent.com/jobs/05f1a4c6-b66f-4698-bb7b-fd0bde30e780/images/d9b1901d906fd26dc9c99a40b96b2ce2550685c04aaa75c5a741680431e422c0.png",
    miami: "https://static.prod-images.emergentagent.com/jobs/05f1a4c6-b66f-4698-bb7b-fd0bde30e780/images/716c46fa5af9881d614c0f732803023ba7653ef36d50e8d742db10ea891ea911.png",
    dc: "https://static.prod-images.emergentagent.com/jobs/05f1a4c6-b66f-4698-bb7b-fd0bde30e780/images/73172a5ef847254fea316879c30b35ca4468d814cc91107690ba750225d55687.png",
  },
  pressTexture: "https://static.prod-images.emergentagent.com/jobs/05f1a4c6-b66f-4698-bb7b-fd0bde30e780/images/5782ffca53209c6c750e7bdec74de264ee022387b10835a6ae5613838a859abc.png",
};

export const VENTURES = [
  {
    id: "court-street",
    name: "Court Street Group",
    city: "Las Vegas",
    region: "Nevada",
    tagline: "Hospitality, entertainment, and high-velocity ventures from the desert capital.",
    description:
      "Court Street Group operates from the entertainment center of the world, building hospitality concepts and high-profile partnerships that move at the speed of Vegas itself.",
    bg: "lasVegas",
    color: "#D9C9A8",
  },
  {
    id: "pacific-standard",
    name: "Pacific Standard Brands",
    city: "Los Angeles",
    region: "California",
    tagline: "A west-coast house for lifestyle, media, and brand architecture.",
    description:
      "Pacific Standard Brands curates a portfolio of lifestyle and media properties out of Los Angeles — a studio for brand systems, talent, and the next generation of consumer identities.",
    bg: "losAngeles",
    color: "#E6CFA1",
  },
  {
    id: "skyline-global",
    name: "Skyline Global",
    city: "New York City",
    region: "New York",
    tagline: "Capital, technology, and global ambition from the financial epicenter.",
    description:
      "Skyline Global is the firm's institutional + technology arm — directing capital strategy, consumer technology, and international operations from the heart of Manhattan.",
    bg: "newYork",
    color: "#C8D1E0",
  },
  {
    id: "santana-enterprises",
    name: "Santana Enterprises",
    city: "Miami",
    region: "Florida",
    tagline: "Cross-border ventures, financial services, and Latin-Atlantic strategy.",
    description:
      "Santana Enterprises is the founder's namesake holding — a Miami-based engine for cross-border opportunity across the Americas, with a focus on travel, financial services, and capital flow.",
    bg: "miami",
    color: "#F2D1B3",
  },
  {
    id: "better-tomorrow",
    name: "Better Tomorrow Initiative",
    city: "Washington DC",
    region: "District of Columbia",
    tagline: "Philanthropy, policy, and opportunity for the next generation.",
    description:
      "The Better Tomorrow Initiative is the philanthropic arm of MPR Ventures — partnering with policymakers, educators, and community leaders to fund the next decade of opportunity.",
    bg: "dc",
    color: "#B5C7D6",
  },
];

// Sub-projects mapped to their parent venture id
export const SUB_PROJECTS = {
  "santana-enterprises": [
    { name: "TruFlights", tagline: "Travel · Aviation", description: "A consumer travel platform built for the new generation of global flyers.", url: "" },
    { name: "Fresh Start Credit", tagline: "Financial wellness", description: "Helping families and individuals rebuild their financial story.", url: "" },
  ],
  "skyline-global": [
    { name: "Skyline", tagline: "Social media app", description: "A new kind of social platform — built around real life, real people, and real signal.", url: "" },
    { name: "Skyline TV", tagline: "Streaming · OTT", description: "A streaming channel for the Skyline Global universe — interviews, original series, and culture.", url: "" },
  ],
  "pacific-standard": [
    { name: "Standard Society", tagline: "Lifestyle · Membership", description: "A lifestyle membership and content house for a new standard of living.", url: "" },
    { name: "Athlete City", tagline: "Sports · Talent", description: "Talent representation, content, and brand-building for the next generation of athletes.", url: "" },
  ],
  "court-street": [],
  "better-tomorrow": [],
};

// TV and Book projects — produced under the Miguel Santana name
export const MEDIA_PROJECTS = [
  {
    name: "Same World",
    type: "TV / Book",
    tagline: "A series & book on the lives we share across cultures, cities, and ambition.",
  },
  {
    name: "Built Different",
    type: "TV / Book",
    tagline: "Profiles of operators, athletes, and founders who refused the default.",
  },
];

// Podcasts — under the Miguel Santana brand
export const PODCASTS = [
  {
    name: "Raise The Standard",
    tagline: "On business, mindset, and refusing average.",
    spotify: "https://open.spotify.com/",
    apple: "https://podcasts.apple.com/",
  },
  {
    name: "Dating Rx",
    tagline: "Modern love, relationships, and what's actually working.",
    spotify: "https://open.spotify.com/",
    apple: "https://podcasts.apple.com/",
  },
  {
    name: "The Voice of Reason",
    tagline: "Unfiltered commentary on culture, society, and the news cycle.",
    spotify: "https://open.spotify.com/",
    apple: "https://podcasts.apple.com/",
  },
  {
    name: "Miguel Talks Sports",
    tagline: "The takes — daily, weekly, and after every big moment.",
    spotify: "https://open.spotify.com/",
    apple: "https://podcasts.apple.com/",
  },
];

// Social handles + Spotify links
export const HANDLE = "@iammiguelsantana";
export const SOCIAL = [
  { name: "Instagram", handle: HANDLE, url: "https://instagram.com/iammiguelsantana", icon: "instagram" },
  { name: "X", handle: HANDLE, url: "https://x.com/iammiguelsantana", icon: "x" },
  { name: "TikTok", handle: HANDLE, url: "https://tiktok.com/@iammiguelsantana", icon: "tiktok" },
  { name: "YouTube", handle: HANDLE, url: "https://youtube.com/@iammiguelsantana", icon: "youtube" },
  { name: "Spotify", handle: "Miguel Santana", url: "https://open.spotify.com/", icon: "spotify" },
  { name: "Apple Podcasts", handle: "Miguel Santana", url: "https://podcasts.apple.com/", icon: "apple" },
];

// Featured-in press logos (display-only, wordmark style)
export const FEATURED_IN = [
  { name: "Forbes", font: "'Playfair Display', serif", weight: 700, style: "normal" },
  { name: "GQ", font: "'Playfair Display', serif", weight: 800, style: "italic" },
  { name: "The New York Times", font: "'UnifrakturCook', 'Playfair Display', serif", weight: 700, style: "normal" },
  { name: "Bloomberg", font: "'Outfit', sans-serif", weight: 800, style: "normal" },
  { name: "Rolling Stone", font: "'Playfair Display', serif", weight: 700, style: "normal" },
  { name: "Esquire", font: "'Outfit', sans-serif", weight: 700, style: "normal", tracking: "0.25em", upper: true },
  { name: "COMPLEX", font: "'Outfit', sans-serif", weight: 900, style: "italic", upper: true },
  { name: "The Breakfast Club", font: "'Outfit', sans-serif", weight: 700, style: "normal" },
  { name: "Men's Health", font: "'Outfit', sans-serif", weight: 800, style: "normal", upper: true, tracking: "0.05em" },
  { name: "Variety", font: "'Playfair Display', serif", weight: 600, style: "normal" },
  { name: "Fast Company", font: "'Outfit', sans-serif", weight: 700, style: "normal" },
];

// "The ThrEEE's to Success" — Miguel Santana's brand pillars
export const PILLARS = [
  { letter: "E", title: "The Educator", description: "Sharing what's been learned — through books, writing, and conversation — so the next generation has fewer reasons to stop." },
  { letter: "E", title: "The Entrepreneur", description: "Building businesses, brands, and platforms that create opportunity, jobs, and long-term value across cities and disciplines." },
  { letter: "E", title: "The Entertainer", description: "Telling stories that move people — through television, podcasts, music, sports, and culture — because attention is how ideas spread." },
];

export const PILLARS_TAGLINE = "The ThrEEE's to Success™";
export const PILLARS_SUMMARY = "Coined by Miguel Santana, The ThrEEE's to Success are the three pillars of his personal brand and the motivation behind his drive and ambition.";

// Contact buckets
export const CONTACT_EMAILS = [
  { label: "Media & Press", value: "media@iammiguelsantana.com" },
  { label: "Podcast & Booking", value: "podcast@iammiguelsantana.com" },
  { label: "Business & Partnerships", value: "business@iammiguelsantana.com" },
  { label: "General", value: "hello@iammiguelsantana.com" },
];
